import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { version as pkgVersion } from '../../package.json';

let cached: string | undefined;

export async function getAppVersion(): Promise<string> {
  if (cached) return cached;

  if (Capacitor.getPlatform() !== 'web') {
    const info = await App.getInfo();
    cached = info.version ? `ORB (${info.version})` : 'unknown';
  } else {
    cached = `ORB (${pkgVersion})`;
  }

  return cached;
}
